module.exports = __webpack_public_path__ + "static/media/elegir.6dbe0176.svg";